export const TIERS = [
  {
    name: "Foundation",
    price: "£99",
    period: "per month",
    badge: "Tablets",
    image: "/plans/foundation.jpg",
    imageAlt: "Androgen Health medicine box with a blister pack of tablets",
    form: "Oral testosterone tablets",
    tagline: "A well-established oral therapy, taken with meals.",
    copy: "Essential ongoing TRT management for eligible patients who suit an oral treatment plan — simple to use, with planned monitoring.",
    feature: "Easy to use — simply take with meals",
    monitoring: "After 3 months, then every 6 months thereafter",
    features: [
      "Oral testosterone prescribed, where clinically appropriate",
      "Monitoring blood tests at 3 months, then every 6 months",
      "Planned clinical reviews with results explained",
      "Prescription and delivery coordination",
      "Digital patient account and monitoring reminders",
      "Clear access to the clinical team",
    ],
    status: "available",
    popular: false,
  },
  {
    name: "Precision",
    price: "£129",
    period: "per month",
    badge: "Creams or depot injections",
    image: "/plans/precision.jpg",
    imageAlt: "Androgen Health transdermal cream pump bottle beside a depot injection vial",
    form: "Transdermal cream or long-acting depot injections",
    tagline: "Dosage tailored to your treatment type and response.",
    copy: "Enhanced monitoring and continuity for patients using a daily cream or a long-acting depot injection given every 10–14 weeks, with the dose and interval tailored to how you respond.",
    feature: "Dosage tailored to treatment type",
    monitoring: "At 3 months, then every 3 months thereafter",
    features: [
      "Testosterone cream or depot injections, where clinically appropriate",
      "Monitoring blood tests at 3 months, then every 3 months",
      "More frequent planned clinical reviews where indicated",
      "Broader investigations where clinically justified",
      "Structured review of treatment response and tolerability",
      "Written treatment summaries and care coordination",
    ],
    status: "available",
    popular: false,
  },
  {
    name: "Specialist",
    price: "£179",
    period: "per month",
    badge: "Premium injectable",
    image: "/plans/specialist.jpg",
    imageAlt: "Androgen Health testosterone injection vial with a 1 mL syringe",
    form: "Premium testosterone injections",
    tagline: "The gold-standard injectable. Our most popular treatment plan.",
    copy: "Premium testosterone injections with the closest clinical oversight — additional specialist reviews, extended results interpretation and detailed coordination with your other clinicians.",
    feature: "The gold-standard injectable",
    monitoring: "After 6 weeks, then every 3 months thereafter",
    features: [
      "Premium injectable testosterone, where clinically appropriate",
      "Monitoring blood tests at 6 weeks, then every 3 months",
      "Additional scheduled specialist reviews",
      "Extended review of complex blood results",
      "Detailed coordination with other healthcare professionals",
      "Enhanced continuity for patients needing closer supervision",
    ],
    status: "available",
    popular: true,
  },
];

export const ONE_OFF_FEES = [
  { service: "Initial testosterone screening blood test", fee: "£35–£49" },
  { service: "Comprehensive diagnostic blood test", fee: "£89–£129" },
  { service: "Initial clinical consultation and results review", fee: "£79–£99" },
  { service: "Existing TRT patient transfer assessment", fee: "£99–£149" },
  { service: "Additional consultation outside the plan", fee: "£49–£79" },
];

export const PLAN_COMPARISON = [
  {
    group: "The basics",
    rows: [
      { label: "Monthly fee (proposed launch pricing)", values: ["£99", "£129", "£179"] },
      { label: "Treatment form", values: ["Oral testosterone tablets", "Transdermal cream or long-acting depot injections", "Premium testosterone injections"] },
      { label: "Key feature", values: ["Easy to use — take with meals", "Dosage tailored to treatment type", "The gold-standard injectable"] },
      { label: "Monitoring blood tests", values: ["After 3 months, then every 6 months", "At 3 months, then every 3 months", "After 6 weeks, then every 3 months"] },
      { label: "Designed for", values: ["Eligible patients who suit a simple oral plan", "Patients using a daily cream or a depot injection every 10–14 weeks", "Patients wanting premium injectables and the closest oversight — our most popular plan"] },
      { label: "Billing & cancellation", values: ["Monthly, clear cancellation policy", "Monthly, clear cancellation policy", "Monthly, clear cancellation policy"] },
    ],
  },
  {
    group: "Clinical care",
    rows: [
      { label: "Prescribed treatment, where clinically appropriate", values: [true, true, true] },
      { label: "Planned clinical reviews", values: ["Standard schedule", "More frequent where indicated", "Additional scheduled specialist reviews"] },
      { label: "Structured review of treatment response & tolerability", values: [false, true, true] },
      { label: "Review of complex blood results", values: [false, "Where indicated", "Extended review included"] },
      { label: "Coordination with other healthcare professionals", values: [false, "Additional coordination for complex cases", "Detailed coordination included"] },
    ],
  },
  {
    group: "Monitoring & investigations",
    rows: [
      { label: "Broader investigations where clinically justified", values: [false, true, true] },
      { label: "Additional investigations when indicated and agreed", values: [false, false, true] },
      { label: "Safety-critical tests or reviews charged as extras", values: ["Never", "Never", "Never"] },
    ],
  },
  {
    group: "Support & continuity",
    rows: [
      { label: "Prescription & treatment administration support", values: [true, true, true] },
      { label: "Digital patient account & monitoring reminders", values: [true, true, true] },
      { label: "Written treatment summaries", values: ["Standard", "More comprehensive", "More comprehensive"] },
      { label: "Access to the clinical team", values: ["Clear access", "Clear access", "Enhanced continuity & closer supervision"] },
    ],
  },
];

export const PRICING_RULES = [
  "Monthly payment with a clear cancellation policy — no unnecessary lock-in.",
  "The full expected cost of the first 12 months is publishable, not just the headline.",
  "Suitable existing blood results are accepted where clinically valid.",
  "Medication formulation and its associated costs are made clear before you commit.",
  "No safety-critical test or review the clinician deems necessary is ever charged as an extra.",
  "Completing an assessment and being advised that TRT is not suitable is a valid outcome — you are never promised treatment by purchasing a test.",
];
